import { rolesTypes } from "../constantes/actionTypes"

const initialState = []

export const rolesList = (state = initialState, action) => {
    switch (action.type) {
        case rolesTypes.GET_ALL_ROLES_SUCCESS:
            return action.payload
        case rolesTypes.GET_ALL_ROLES_FAILURE:
            return initialState
        default:
            return state
    }
}